export default __webpack_public_path__ + "static/media/07_motor_Personalizacion.98d30396.svg";